module.exports = __webpack_public_path__ + "img/banner26.51315e91.png";